import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { register, registerByLink } from "../../Requests/User/UserRequests";
import cassete from "../../Assets/casset.png";

import logo from "../../Assets/logo.png";
import SuccesModal from "../../Components/SuccesModal";
import ErrorModal from "../../Components/ErrorModal";
import { useTranslation } from "react-i18next";
import Loader from "../../Components/Loader";
import Cookies from "universal-cookie";
import { setSecureCookie } from "../../utils/cookies";
import { useMyContext } from "../../Components/ContextProviders/CreditsContextProvider";
import i18n from "../../i18n";

function RegisterByLink() {
  const [goToLogin, setGoToLogin] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { confirmation_token } = useParams();
  const { setCredits } = useMyContext();
  const { language } = useParams()
  const [userLanguage, setUserLanguage] = useState(language || "en")

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
      localStorage.setItem("language", language)
    }
  }, [])

  const handleSelectChange = (event) => {
    setUserLanguage(event.target.value);
  };

  let handleSubmit = (event) => {
    setFeedbackModal(false)
    setIsLoading(true);
    event.preventDefault();
    let data = {
      "confirmation_token": confirmation_token,
      "name": event.target.name.value,
      "password": event.target.password.value,
      "password_confirmation": event.target.password_confirmation.value,
      language: userLanguage || "en"
    }
    let response = registerByLink(data)
    response.then((res) => {
      setIsLoading(false);
      setSecureCookie("token", res.data.token);
      setSecureCookie("user_id", res.data.user_id);
      setSecureCookie("credits", res.data.credits);
      setCredits(res.data.credits);
      setSecureCookie("team_uuid", res.data.team_uuid);
      navigate(`/dashboard`);
    })
      .catch((error) => {
        setIsLoading(false)
        error?.response?.data?.errors?.email ? (
          setFeedbackModal(
            <ErrorModal
              title={t('RegisterPage.FailModalTitle')}
              body={error?.response?.data?.errors?.email}
              continue={t('RegisterPage.FailModalButton')}
            />
          )) : error?.response?.data?.errors?.password ? (
            setFeedbackModal(
              <ErrorModal
                title={t('RegisterPage.FailModalTitle')}
                body={error?.response?.data?.errors?.password}
                continue={t('RegisterPage.FailModalButton')}
              />
            )) : <ErrorModal
          title={t('RegisterPage.FailModalTitle')}
          body={t('RegisterPage.FailModalText')}
          continue={t('RegisterPage.FailModalButton')}
        />

      });
  };

  function redirectToLogin() {
    setGoToLogin(true);
  }

  useEffect(() => {
    if (goToLogin) {
      navigate(`/login`);
    }
  }, [goToLogin]);

  return (
    <>
      <div className="flex min-h-full bg-white">
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={cassete}
            alt=""
          />
        </div>
        <div className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <div className="w-full flex justify-center">
                <img className="h-32 w-auto" src={logo} alt="Your Company" />
              </div>
              <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
                {t('RegisterPage.PageTitle')}
              </h2>
            </div>

            <div className="mt-8">
              <div className="mt-6">
                <form className="space-y-6" onSubmit={handleSubmit}>
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t('RegisterPage.NameField')}
                    </label>
                    <div className="mt-1">
                      <input
                        id="name"
                        name="name"
                        type="text"
                        required
                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-black focus:outline-none focus:ring-black sm:text-sm"
                      />
                    </div>
                  </div>

                  <div className="space-y-1">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t('RegisterPage.PasswordField')}
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        required
                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-black focus:outline-none focus:ring-black sm:text-sm"
                      />
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t('RegisterPage.ConfirmPasswordField')}
                    </label>
                    <div className="mt-1">
                      <input
                        id="password_confirmation"
                        name="password_confirmation"
                        type="password"
                        required
                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-black focus:outline-none focus:ring-black sm:text-sm"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">
                      {t('TranscriptionUploadModal.Language')}
                    </label>
                    <select
                      id="location"
                      name="location"
                      className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-black sm:text-sm sm:leading-6"
                      defaultValue={userLanguage}
                      onChange={handleSelectChange}
                    >
                      <option>  {t('Audio.AudioUpload.Step2.LanguageOption1')}</option>
                      <option>  {t('Audio.AudioUpload.Step2.LanguageOption2')}</option>
                    </select>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="text-sm">
                      <a
                        onClick={redirectToLogin}
                        className="font-medium text-black hover:text-black"
                      >
                        {t('RegisterPage.LoginLink')}
                      </a>
                    </div>
                  </div>

                  <div><button
                    type="submit"
                    className="flex w-full justify-center rounded-md border border-transparent bg-black py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                  >
                    {isLoading ? <Loader /> :
                      t('RegisterPage.SubmitButton')
                    }
                  </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {feedbackModal}
      </div>
    </>
  );
}

export default RegisterByLink;
